import {LoaderInlineStyl, LoaderSvgStyl, LoaderWrapper} from './Loader.styl';

export type LoaderProps = {
  variant?: 'white' | 'red' | 'green' | 'blue' | 'currentcolor';
  model?: 'round' | 'inline';
};

const Loader = ({variant = 'red', model = 'round'}: LoaderProps): JSX.Element => {
  return (
    <LoaderWrapper className={`loader loader--${model}`}>
      {model === 'round' ? (
        <LoaderSvgStyl
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="currentcolor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M2.63671 2.63671C2.85468 2.41874 3.21328 2.41874 3.43124 2.63671L5.81835 5.02382C6.03632 5.24179 6.03632 5.60038 5.81835 5.81835C5.60038 6.03632 5.24179 6.03632 5.02382 5.81835L3.83027 4.6248L2.63671 3.43124C2.41874 3.21328 2.41874 2.85468 2.63671 2.63671Z" fill="currentColor"/>
          <path d="M0.5625 8.43747C0.253125 8.43747 0 8.69059 0 8.99997C0 9.30934 0.253125 9.56247 0.5625 9.56247H3.9375C4.24687 9.56247 4.5 9.30934 4.5 8.99997C4.5 8.69059 4.24687 8.43747 3.9375 8.43747H0.5625Z" fill="currentColor"/>
          <path d="M3.43124 15.3633L5.81835 12.9762C6.03632 12.7582 6.03632 12.3996 5.81835 12.1816C5.60038 11.9637 5.24179 11.9637 5.02382 12.1816L2.63671 14.5687C2.41874 14.7867 2.41874 15.1453 2.63671 15.3633C2.85468 15.5812 3.21328 15.5812 3.43124 15.3633Z" fill="currentColor"/>
          <path d="M9.5625 17.4375V14.0625C9.5625 13.7531 9.30938 13.5 9 13.5C8.69062 13.5 8.4375 13.7531 8.4375 14.0625V15.75V17.4375C8.4375 17.7468 8.69062 18 9 18C9.30938 18 9.5625 17.7468 9.5625 17.4375Z" fill="currentColor"/>
          <path d="M15.3633 14.5687L12.9762 12.1816C12.7582 11.9637 12.3996 11.9637 12.1816 12.1816C11.9637 12.3996 11.9637 12.7582 12.1816 12.9762L14.5687 15.3633C14.7867 15.5812 15.1453 15.5812 15.3633 15.3633C15.5812 15.1453 15.5812 14.7867 15.3633 14.5687Z" fill="currentColor"/>
          <path d="M17.4375 8.43747H14.0625C13.7531 8.43747 13.5 8.69059 13.5 8.99997C13.5 9.30934 13.7531 9.56247 14.0625 9.56247H17.4375C17.7469 9.56247 18 9.30934 18 8.99997C18 8.69059 17.7469 8.43747 17.4375 8.43747Z" fill="currentColor"/>
          <path d="M15.3633 3.43124C15.5812 3.21328 15.5812 2.85468 15.3633 2.63671C15.1453 2.41874 14.7867 2.41874 14.5687 2.63671L12.1816 5.02382C11.9637 5.24179 11.9637 5.60038 12.1816 5.81835C12.3996 6.03632 12.7582 6.03632 12.9762 5.81835L15.3633 3.43124Z" fill="currentColor"/>
          <path d="M9.5625 3.93747V0.562469C9.5625 0.253094 9.30938 -3.05176e-05 9 -3.05176e-05C8.69062 -3.05176e-05 8.4375 0.253094 8.4375 0.562469V3.93747C8.4375 4.24684 8.69062 4.49997 9 4.49997C9.30938 4.49997 9.5625 4.24684 9.5625 3.93747Z" fill="currentColor"/>
        </LoaderSvgStyl>
      ) : (
        <LoaderInlineStyl className={`loader loader-${model}`}>
          <span className="loader--inline-bar" />
        </LoaderInlineStyl>
      )
      }
    </LoaderWrapper>
  );
};

export default Loader;
